<section class="container-fluid temp-color">
  <div class="row">
    <div class="col-sm-2 padding-left">
      <security-navigation class="sticky-nav"> </security-navigation>
    </div>
    <div class="col-sm-10 padding-left">
      <h1 id="main-title" class="page-title ng-binding">
        Book Case
      </h1>
      @if (errorMessage?.message?.length > 0) {
        <div class="margin-bottom">
          <nfrp-alert alertId="add-mm-error" [message]="errorMessage" type="error" [page]="false"> </nfrp-alert>
        </div>
      }
      @if (infoMessage?.message?.length > 0) {
        <div class="margin-bottom">
          <nfrp-alert alertId="info-msg" [message]="infoMessage" type="info" [page]="false"> </nfrp-alert>
        </div>
      }
      @if (generalTitle?.length > 0) {
        <div>
          <ul class="ul-li-view-edit table stripes no-margin border-ul">
            <li class="head">
              <div class="col-sm-12 padding-left">
                <b>General Titles</b>
              </div>
            </li>
            @for (data of generalTitle; track data) {
              <li>
                <div class="col-sm-12">
                  <a href="javascript:void(0);" (click)="downloadBookCaseFile(data)">{{ data?.bookLabel }}</a>
                </div>
              </li>
            }
          </ul>
        </div>
      }
      @if (thirdPartyAdmin?.length > 0) {
        <div>
          <ul class="ul-li-view-edit table stripes no-margin border-ul mt-10">
            <li class="head">
              <div class="col-sm-12 padding-left">
                <b>Third-Party Administrator Information</b>
              </div>
            </li>
            @for (data of thirdPartyAdmin; track data) {
              <li>
                <div class="col-sm-12">
                  <a href="javascript:void(0);" (click)="downloadBookCaseFile(data)">{{ data?.bookLabel }}</a>
                </div>
              </li>
            }
          </ul>
        </div>
      }
      @if (tpa?.length > 0) {
        <div>
          <ul class="ul-li-view-edit table stripes no-margin border-ul mt-10">
            <li class="head">
              <div class="col-sm-12 padding-left">
                <b>TPA Team Information</b>
              </div>
            </li>
            @for (data of tpa; track data) {
              <li>
                <div class="col-sm-12">
                  <a href="javascript:void(0);" (click)="downloadBookCaseFile(data)">{{ data?.bookLabel }}</a>
                </div>
              </li>
            }
          </ul>
        </div>
      }
      @if (moneyManager?.length > 0) {
        <div>
          <ul class="ul-li-view-edit table stripes no-margin border-ul mt-10">
            <li class="head">
              <div class="col-sm-12 padding-left">
                <b>Money Manager Information</b>
              </div>
            </li>
            @for (data of moneyManager; track data) {
              <li>
                <div class="col-sm-12">
                  <a href="javascript:void(0);" (click)="downloadBookCaseFile(data)">{{ data?.bookLabel }}</a>
                </div>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
</section>
